function navbarInit() {
	const navPopup = document.querySelector(".nav-popup")
	document.querySelector(".btn-open-main-nav").addEventListener("click", e => {
		navPopup.classList.add("show");
	});

	document.querySelector(".btn-close-main-nav").addEventListener("click", e => {
		navPopup.classList.remove("show");
	});
}

function faqInit() {
	document.querySelectorAll(".faq-item-toggler").forEach(item => {
		item.addEventListener("click", e => {
			const btn = e.currentTarget;
			const container = btn.parentNode;
			const answerBlockHeight = container.querySelector(".answer").getBoundingClientRect().height;
			const containerCurrentHeight = container.getBoundingClientRect().height;

			if(!container.classList.contains("show")) {
				container.classList.add("show");
				let height = answerBlockHeight + containerCurrentHeight;
				container.style.height = height + "px";
			} else {
				let height = containerCurrentHeight - answerBlockHeight;
				container.classList.remove("show");
				container.style.height = height + "px";
			}
		});
	});
}

function meetInit() {
	document.querySelectorAll(".teammate-card-toggler").forEach(item => {
		item.addEventListener("click", e => {
			const btn = e.currentTarget;
			const card = btn.parentNode.parentNode.parentNode;
			const aboutWrap = card.querySelector(".about-wrap");
			const about = aboutWrap.querySelector(".about");

			if(!card.classList.contains("show")) {
				card.classList.add("show");
				aboutWrap.style.height = about.getBoundingClientRect().height + "px";
				if(window.innerWidth >= 1540) {
					card.style.position = "absolute";
				}
			} else {
				card.classList.remove("show");
				aboutWrap.style.height = 0;
				setTimeout(() => {
					card.style.position = "static";
				}, 200);
			}
		});
	});
}

function treatmentInit() {
	const popup = document.querySelector(".treatment-details-popup");
	
	document.querySelector(".show-treatment")?.addEventListener("click", e => {
		popup.classList.add("show");
	});

	document.querySelector(".close-treatment-popup")?.addEventListener("click", e => {
		popup.classList.remove("show");
	});
}

function contactFormInit() {
	const popup = document.querySelector(".contact-form-popup");
	
	document.querySelector(".apply-btn")?.addEventListener("click", e => {
		popup.classList.add("show");
	});

	document.querySelector(".close-contact-form-popup")?.addEventListener("click", e => {
		popup.classList.remove("show");
	});

	document.querySelector("#cv-file")?.addEventListener("change", e => {
		let filename = e.currentTarget.value.split('\\').reverse()[0];
		if(filename == "") {
			filename = e.currentTarget.dataset.defaultText;
		}
		document.querySelector(".upload-btn .text").innerHTML = filename;
	});

	document.querySelector("form.contact-form")?.addEventListener("submit", e => {
		e.preventDefault();

		document.querySelector(".contact-form-popup .loader.spinner").classList.add("show");

		const xhr = new XMLHttpRequest();
		xhr.open(e.currentTarget.getAttribute("method"), e.currentTarget.getAttribute("action"));
		
		xhr.onload = function(){
			if(xhr.status != 200) {
				return console.error("Error of request");
			}

			document.querySelector(".contact-form-popup .loader.spinner").classList.remove("show");
			document.querySelector(".contact-form-popup .loader.message").classList.add("show");
			setTimeout(() => {
				document.querySelector(".contact-form-popup .loader.message").classList.remove("show");
				document.querySelector("form.contact-form").reset();

				setTimeout(() => {
					document.querySelector(".close-contact-form-popup").click();
				}, 300);
			}, 3500);

			console.log(xhr.response);
		}

		xhr.send(new FormData(e.currentTarget));
	});
}

function reviewFormInit() {
	const popup = document.querySelector(".review-form-popup");
	
	document.querySelector(".open-review-popup")?.addEventListener("click", e => {
		popup.classList.add("show");
	});

	document.querySelector(".close-review-form-popup")?.addEventListener("click", e => {
		popup.classList.remove("show");
	});

	document.querySelectorAll(".review-form-popup textarea").forEach(i => {
		i.addEventListener("input", e => {
		  e.currentTarget.style.height = "5px";
		  e.currentTarget.style.height = (e.currentTarget.scrollHeight) + "px";
		});
	})

	document.querySelector("form.review-form")?.addEventListener("submit", e => {
		e.preventDefault();

		document.querySelector(".review-form-popup .loader.spinner").classList.add("show");

		const xhr = new XMLHttpRequest();
		xhr.open(e.currentTarget.getAttribute("method"), e.currentTarget.getAttribute("action"));
		
		xhr.onload = function(){
			if(xhr.status != 200) {
				return console.error("Error of request");
			}

			document.querySelector(".review-form-popup .loader.spinner").classList.remove("show");
			document.querySelector(".review-form-popup .loader.message").classList.add("show");
			setTimeout(() => {
				document.querySelector(".review-form-popup .loader.message").classList.remove("show");
				document.querySelector("form.review-form").reset();

				setTimeout(() => {
					document.querySelector(".close-review-form-popup").click();
				}, 300);
			}, 3500);

			console.log(xhr.response);
		}

		xhr.send(new FormData(e.currentTarget));
	});
}

function navInit() {
	const pathname = document.location.pathname;
	approvedPathnames = ["/", "/pl", "/uk", "/en", "/pl/", "/uk/", "/en/"];

	if(approvedPathnames.indexOf(pathname) != -1) {
		document.querySelectorAll('.nav-item .nav-link').forEach(item => {
			item.addEventListener('click', function (e) {
				if(this.getAttribute('href').indexOf("p-") != -1) {
					e.preventDefault();
					goToPageBlock("#" + this.getAttribute('href').split("#")[1], true);
					document.querySelector(".btn-close-main-nav").click();
				}
			});
		});
	}

	setTimeout(() => {
		if(document.location.hash.indexOf("p-") != -1) {
			goToPageBlock(document.location.hash);
		}
	}, 100);
}

let currentPageBlock = '';

function goToPageBlock(selector, nocheck) {
	selector = selector.replace("#p-", "#page-");
	if(!nocheck && currentPageBlock == selector) {
		return;
	}

	console.log(selector);
	currentPageBlock = selector;
	document.querySelector(selector)?.scrollIntoView({
		behavior: 'smooth'
	});
}

document.addEventListener("DOMContentLoaded", e => {
	console.log("App start");

	navbarInit();
	faqInit();
	meetInit();
	treatmentInit();
	navInit();

	const helpBtn = document.querySelector(".help-btn");
	const htmlElement = document.querySelector("html");

	const menuBtn = document.querySelector(".btn-open-main-nav");

	window.addEventListener("scroll", e => {
		const scrollHeight = document.body.scrollHeight - window.innerHeight;
		const self = e.currentTarget;
		if(scrollHeight - htmlElement.scrollTop > 100) {
			if(helpBtn.classList.contains("hide")) {
				helpBtn.classList.remove("hide");
			}
		} else {
			helpBtn.classList.add("hide");
		}

		if(htmlElement.scrollTop > 50) {
			menuBtn.classList.add("with-bg");
		} else {
			menuBtn.classList.remove("with-bg");
		}
	});

	document.querySelectorAll("[data-click-on-selector]").forEach(item => {
		item.addEventListener("click", e => {
			e.preventDefault();
			document.querySelector(e.currentTarget.dataset.clickOnSelector).click();
		});
	})

	contactFormInit();
	reviewFormInit();

	jQuery(".reviews .slick-container").slick({
	  slidesToShow: 4,
	  slidesToScroll: 1,
	  autoplay: false,
	  dots: true,
	  responsive: [
	  	{
	  		breakpoint: 1540,
	  		settings: {
	  			slidesToShow: 3
	  		}
	  	},
	  	{
	  		breakpoint: 1200,
	  		settings: {
	  			slidesToShow: 2,
	  			centerMode: false,
	  		}
	  	},
	  	{
	  		breakpoint: 768,
	  		settings: {
	  			slidesToShow: 1,
	  			centerMode: false,
	  			arrows: false,
	  		}
	  	}
	  ]
	});

	document.querySelector("#home-bg-video").addEventListener("canplay", e => {
		e.currentTarget.classList.add("show");
	});
});